import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import {
  FormBaseControlService,
  AlertService,
  GTagService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { CreateAccountService } from '../../../../_services/forms/create-account/create-account-service.service';
import { MobileOtpService } from '../../../../_services/mobile-otp/mobile-otp.service';
import { Router , RouterModule } from '@angular/router';
import { UserService } from '../../../../_services/user.service';
import { ClientCredentialsService } from '../../../../_services/client-credentials/client-credentials.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, MapfreIputWithValidationComponent],
  selector: 'app-phone-otp',
  templateUrl: './phone-otp.component.html',
  styleUrls: ['./phone-otp.component.scss'],
})
export class PhoneOtpComponent implements OnInit {
  inputs: any[];
  phoneOtpForm: FormGroup;
  newCode = false;
  codeExpired = false;
  isAcmic = false;
  phoneNum: any;
  userData: any;

  constructor(
    private service: CreateAccountService,
    private ipt: FormBaseControlService,
    private mobileOtpService: MobileOtpService,
    private router: Router,
    private userService: UserService,
    private alertService: AlertService,
    private clientCredentialsService: ClientCredentialsService,
    private gTagService: GTagService,
    private acmicService: AcmicService,
    private translate: TranslateService
  ) {
    this.inputs = service.getPhoneOtpInputs();
  }

  ngOnInit(): void {
    this.phoneOtpForm = this.ipt.toFormGroup(this.inputs);
    this.isAcmic = this.acmicService.isACMIC();
    this.getPhoneNum();
  }

  getPhoneNum() {
    this.userService.$user.subscribe((user) => {
      if (user) {
        this.userData = user.userDetails;
        this.phoneNum = this.userData.phone
          ? this.maskPhone(user.userDetails.phone)
          : null;
      }
    });
  }
  maskPhone(phn) {
    const len = phn.length;
    return '*'.repeat(len - 4) + phn.substr(len - 4);
  }

  verfiyOtp() {
    const enteredOtp = this.phoneOtpForm.get('validateOtp').value;
    this.mobileOtpService
      .validatePasscode(this.userData.phone, enteredOtp, ' ')
      .subscribe(
        (resp) => {
          this.gTagService.triggerFormLink('phoneOtpForm', 'true', '');
          if (resp) {
            this.router.navigate(['/signup', 'confirm-email']);
          } else {
            this.codeExpired = true;
          }
        },
        (err) => {
          this.gTagService.triggerFormLink(
            'phoneOtpForm',
            'false',
            this.translate.instant('VERIFY_OTP_ERROR')
          );
          this.codeExpired = true;
          if (err.status === 401) {
            this.clientCredentialsService.getToken().subscribe(() => {
              this.verfiyOtp();
            });
          }
        }
      );
  }

  sendNewCode() {
    this.phoneOtpForm.get('validateOtp').patchValue('');
    this.mobileOtpService.generatePasscode(this.userData.phone).subscribe(
      (resp) => {
        if (resp) {
          this.gTagService.triggerFormLink('phoneOtpForm', 'true', '');
          this.codeExpired = false;
          this.alertService.success(
            'WE_HAVE_SENT_YOU_NEW_CODE',
            false,
            '',
            'white'
          );
        } else {
          this.alertService.error('PROBLEM_SENDING_OTP', false);
          this.codeExpired = true;
        }
      },
      () => {
        this.gTagService.triggerFormLink(
          'phoneOtpForm',
          'false',
          this.translate.instant('SEND_OTP_ERROR')
        );
      }
    );
  }
}
